// extracted by mini-css-extract-plugin
module.exports = {"split":"create_split___ygmj","paneLeft":"create_paneLeft__2dLus","paneRight":"create_paneRight__3RsZX","pane":"create_pane__1qBMy","loadingSpinner":"create_loadingSpinner__1pNZZ"};